import styled from "styled-components"

import {H4} from "@irati/ui/src/Typography"

export default styled(H4)`

  > span:first-child {
    margin-right: 5px
  }
`
